




















import {Component, Prop, Vue} from "vue-property-decorator";
import {SegmentationTarget} from "@/modules/Segmentation/models/SegmentationTarget";

@Component
export default class SegmentationNestingApprove extends Vue {
    @Prop() public readonly value!: boolean;
    @Prop() public readonly segmentationTarget!: SegmentationTarget;

    agree(): void {
        this.$emit("agree");
        this.$emit("input", false);
    }
}
